import React from 'react';

export interface StatusChipOption {
    value: string;
    label: string;
    count: number;
}

interface StatusFilterChipsProps {
    options: StatusChipOption[];
    value: string;
    onChange: (value: string) => void;
}

// Remplace la navigation par onglets des tableaux de suivi (Commandes/Extras) — chips de filtre par statut
// au-dessus d'un tableau continu, avec "Tous" par défaut. Filtrage en mémoire côté module appelant, ce
// composant ne fait que refléter la sélection.
export const StatusFilterChips: React.FC<StatusFilterChipsProps> = ({ options, value, onChange }) => {
    const total = options.reduce((sum, o) => sum + o.count, 0);
    const all: StatusChipOption = { value: 'all', label: 'Tous', count: total };
    return (
        <div className="flex items-center gap-2 flex-wrap">
            {[all, ...options].map((opt) => (
                <button key={opt.value} onClick={() => onChange(opt.value)}
                    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold border transition-colors ${
                        value === opt.value
                            ? 'bg-brand-600 border-brand-600 text-white'
                            : 'bg-surface border-border text-content-muted hover:text-content hover:border-brand-500/40'
                    }`}>
                    {opt.label}
                    <span className={`text-[10px] ${value === opt.value ? 'text-white/80' : 'text-content-muted'}`}>({opt.count})</span>
                </button>
            ))}
        </div>
    );
};
